var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndOfImagesDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 278,
    viewBox: "0 0 285 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.3 129.916V65.7998C199.3 61.4922 195.09 58.4426 190.997 59.7846L138.304 77.0611C135.704 77.9136 133.946 80.3401 133.946 83.0763V142.606C133.946 146.914 138.155 149.963 142.248 148.621L199.3 129.916ZM199.3 129.916L186.179 156.276",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.229 144.5V151.177C183.229 155.485 187.438 158.535 191.531 157.193L219.717 147.951C222.317 147.099 224.075 144.672 224.075 141.936V82.2661C224.075 78.0275 219.934 75.0269 215.906 76.3474V76.3474L207.737 79.0258",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.95 72.5C116.95 69.9869 118.987 67.9495 121.5 67.9495C124.013 67.9495 126.05 69.9869 126.05 72.5V199.5C126.05 202.013 124.013 204.05 121.5 204.05C118.987 204.05 116.95 202.013 116.95 199.5V72.5Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0505 78.1152C35.0505 82.8865 31.3984 86.6657 27 86.6657C22.6016 86.6657 18.9495 82.8865 18.9495 78.1152C18.9495 73.3439 22.6016 69.5648 27 69.5648C31.3984 69.5648 35.0505 73.3439 35.0505 78.1152Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 198.009,
    cy: 28.5,
    r: 12.5505,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter5_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.146 241.572L125.994 241.163L130.772 248.621L126.701 256.488L117.853 256.897L113.076 249.438L117.146 241.572Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.637 202.861L253.276 195.316L262.13 195.561L266.345 203.352L261.705 210.897L252.852 210.652L248.637 202.861Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter7_d_3188_100662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.9449,
    y: 110.778,
    width: 30.053,
    height: 30.053,
    transform: "rotate(15 55.9449 110.778)",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3188_100662",
    x: 115.904,
    y: 43.955,
    width: 101.436,
    height: 132.895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3188_100662",
    x: 165.188,
    y: 60.5229,
    width: 76.9291,
    height: 117.563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3188_100662",
    x: 98.9083,
    y: 52.4404,
    width: 45.1835,
    height: 172.183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3188_100662",
    x: 0.908258,
    y: 54.0556,
    width: 52.1835,
    height: 53.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3188_100662",
    x: 167.417,
    y: 0.440368,
    width: 61.1835,
    height: 61.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3188_100662",
    x: 94.8887,
    y: 225.63,
    width: 54.0697,
    height: 51.8646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3188_100662",
    x: 230.449,
    y: 179.792,
    width: 54.0834,
    height: 51.6932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3188_100662",
    x: 29.9117,
    y: 95.0556,
    width: 73.3168,
    height: 73.3168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3188_100662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3188_100662",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndOfImagesDark);
export default __webpack_public_path__ + "static/media/end-of-images-dark.847fd8e6bb75bb528f026e9efd275dff.svg";
export { ForwardRef as ReactComponent };